import { createContext } from "react";

const CardGridContext = createContext();

export const CardGridProvider = ({ children }) => {
  const getCardGridState = () => {
    try {
      const stored = localStorage.getItem("Tilley-CardGridView-States");
      return stored ? JSON.parse(stored) : {};
    } catch (error) {
      console.error("Failed to parse CardGridView state from localStorage:", error);
      return {};
    }
  };

  const setCardGridState = (gridKey, state) => {
    const existingState = getCardGridState();
    const updatedState = {
      ...existingState,
      [gridKey]: state,
    };
    localStorage.setItem("Tilley-CardGridView-States", JSON.stringify(updatedState));
  };

  return <CardGridContext.Provider value={{ getCardGridState, setCardGridState }}>{children}</CardGridContext.Provider>;
};

export default CardGridContext;
